"use strict";

var _classCallCheck = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Feature = void 0;
/**
 * A Feature.
 */

var Feature = function Feature(options, deps) {
  _classCallCheck(this, Feature);

  this.hookManager = deps.hookManager;
  this.resources = deps.resources;
  this.services = deps.services;
  this.root = deps.root;
  this.options = options;
  this.appOptions = deps.root.appOptions;
};

exports.Feature = Feature;